import React from 'react';

import { Icon } from '../icons';

export const PlusCircledIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 25 25" fill={color} style={style}>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5 8.19193C12.8757 8.19193 13.1803 8.49648 13.1803 8.87216V11.8198H16.1279C16.5036 11.8198 16.8082 12.1244 16.8082 12.5001C16.8082 12.8757 16.5036 13.1803 16.1279 13.1803H13.1803V16.128C13.1803 16.5037 12.8757 16.8082 12.5 16.8082C12.1244 16.8082 11.8198 16.5037 11.8198 16.128V13.1803H8.87213C8.49644 13.1803 8.19189 12.8757 8.19189 12.5001C8.19189 12.1244 8.49644 11.8198 8.87213 11.8198H11.8198V8.87216C11.8198 8.49648 12.1244 8.19193 12.5 8.19193Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5 4.11047C7.86659 4.11047 4.11047 7.86659 4.11047 12.5C4.11047 17.1334 7.86659 20.8895 12.5 20.8895C17.1334 20.8895 20.8895 17.1334 20.8895 12.5C20.8895 7.86659 17.1334 4.11047 12.5 4.11047ZM2.75 12.5C2.75 7.11522 7.11522 2.75 12.5 2.75C17.8848 2.75 22.25 7.11522 22.25 12.5C22.25 17.8848 17.8848 22.25 12.5 22.25C7.11522 22.25 2.75 17.8848 2.75 12.5Z"
        />
      </g>
    </svg>
  );
};
